import ImgCom from "components/ImgCom"
import { Column, Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import daoRewardGreen from 'assets/images/dao_reward_green.png'
import daoRewardYellow from 'assets/images/dao_reward_yellow.png'
import daoRewardGray from 'assets/images/dao_reward_gray.png'
import { AddNewBtnLabelWrap, AddNewBtnWrap } from ".."
import useDao from "hooks/useDao"
import { useCallback, useEffect, useState } from "react"
import { formatNum } from "utils"
import LoadingWin from "components/LoadingWin"

const RewardsCom = () => {
    const { getVShareClaimableForAll, getVShareClaimedForAll, checkHasVal, isLock, claimable, claimed, claimRewards, getCurrentPeriod, getClaimEnabled  } = useDao(false)
    const [curClaimEnabled, setCurClaimEnabled] = useState<any>({})
    useEffect(() => {
        getVShareClaimableForAll()
        getVShareClaimedForAll()
    }, [getVShareClaimableForAll, getVShareClaimedForAll, getCurrentPeriod])

    useEffect(() => {
        const fnTemp = async () => {
            const fullYear = new Date().getFullYear()
            const allRequest = [getClaimEnabled(`${fullYear}01`), getClaimEnabled(`${fullYear}02`), getClaimEnabled(`${fullYear}03`), getClaimEnabled(`${fullYear}04`)]
            const resultList = await Promise.all(allRequest)
            if(resultList.length) {
                setCurClaimEnabled({
                    q1: resultList[0],
                    q2: resultList[1],
                    q3: resultList[2],
                    q4: resultList[3],
                })
            }
        }
        fnTemp()
    }, [getClaimEnabled])

    const fnClaimRewards = useCallback(async (period: string) => {
        try {
            await claimRewards(period)
            // refresh status
            setTimeout(() => {
                getVShareClaimableForAll()
                getVShareClaimedForAll()
            }, 1000);
        } catch(error) {
            
        }
    }, [claimRewards, getVShareClaimableForAll, getVShareClaimedForAll])

    const rewardNode = (isClaimed: boolean, claimable: any, claimed: any) => {
        const isClaimable = checkHasVal(claimable)
        return <Row>
            <ValWrap>
                <span>USDT Rewards:</span>
                {
                   (isClaimed || isClaimable) && <div>{formatNum(isClaimed ? claimed?.USDT : claimable?.USDT, 2)} USDT</div>
                }
                {
                    !(isClaimed || isClaimable) && <div>N/A</div>
                }
            </ValWrap>
            <ValWrap>
                <span>USDC Rewards:</span>
                {
                    (isClaimed || isClaimable) && <div>{formatNum(isClaimed ? claimed?.USDC : claimable?.USDC, 2)} USDC</div>
                }
                {
                    !(isClaimed || isClaimable) && <div>N/A</div>
                }
            </ValWrap>
            <ValWrap>
                <span>WBTC Rewards:</span>
                {
                    (isClaimed || isClaimable) && <div>{formatNum(isClaimed ? claimed?.WBTC : claimable?.WBTC, 2)} WBTC</div>
                }
                {
                    !(isClaimed || isClaimable) && <div>N/A</div>
                }
            </ValWrap>
            <ValWrap>
                <span>ETH Rewards:</span>
                {
                    (isClaimed || isClaimable) && <div>{formatNum(isClaimed ? claimed?.ETH : claimable?.ETH, 2)} ETH</div>
                }
                {
                    !(isClaimed || isClaimable) && <div>N/A</div>
                }
            </ValWrap>
            <ValWrap>
                <span>XCHNG Rewards:</span>
                {
                    (isClaimed || isClaimable) && <div>{formatNum(isClaimed ? claimed?.XCHNG : claimable?.XCHNG, 2)} XCHNG</div>
                }
                {
                    !(isClaimed || isClaimable) && <div>N/A</div>
                }
            </ValWrap>
        </Row>
    }

    const getImg = (claimed: any, claimable: any) => {
        if(checkHasVal(claimed)) {
            return daoRewardGreen
        }
        if(checkHasVal(claimable)) {
            return daoRewardYellow
        }
        return daoRewardGray
    }

    return <div>
        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6>Your rewards</StyledContainer>
        <StyledContainer $height="20px"></StyledContainer>
        {/* <CardWrap>
            <Row>
                <ImgCom imgUrl={getImg(claimed.q1, claimable.q1)} width="70px" height="70px"></ImgCom>
                <StyledContainer $ml="20px" $fontSize="16px" $fontWeight6 $lineHeight="1">Q1 2024 Rewards</StyledContainer>
            </Row>
            <StyledContainer $height="20px"></StyledContainer>
            {
                rewardNode(checkHasVal(claimed?.q1), claimable?.q1, claimed?.q1)
            }
            <StyledContainer $height="32px"></StyledContainer>
            {
                checkHasVal(claimed.q1) && <ClaimedWrap>Rewards were claimed</ClaimedWrap>
            }
            {
                !checkHasVal(claimed.q1) && curClaimEnabled.q1 && checkHasVal(claimable.q1) &&  <AddNewBtnWrap $alignSelf="flex-start" onClick={() => fnClaimRewards('202401')}>
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold>Claim all rewards</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            }
            {
                !curClaimEnabled.q1 && <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F">
                    You will be able to claim the rewards once they become available
                </StyledContainer>
            }
        </CardWrap> */}

        <CardWrap>
            <Row>
                <ImgCom imgUrl={getImg(claimed.q2, claimable.q2)} width="70px" height="70px"></ImgCom>
                <StyledContainer $ml="20px" $fontSize="16px" $fontWeight6 $lineHeight="1">Q2 2024 Rewards</StyledContainer>
            </Row>
            <StyledContainer $height="20px"></StyledContainer>
            {
                rewardNode(checkHasVal(claimed.q2), claimable?.q2, claimed?.q2)
            }
            <StyledContainer $height="32px"></StyledContainer>
            {
                checkHasVal(claimed.q2) && <ClaimedWrap>Rewards were claimed</ClaimedWrap>
            }
            {
                !checkHasVal(claimed.q2) && curClaimEnabled.q2 && checkHasVal(claimable.q2) && <AddNewBtnWrap $alignSelf="flex-start">
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold onClick={() => fnClaimRewards('202402')}>Claim all rewards</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            }
            {
                !curClaimEnabled.q2 && <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F">
                    You will be able to claim the rewards once they become available
                </StyledContainer>
            }
        </CardWrap>

        <CardWrap>
            <Row>
                <ImgCom imgUrl={getImg(claimed.q3, claimable.q3)} width="70px" height="70px"></ImgCom>
                <StyledContainer $ml="20px" $fontSize="16px" $fontWeight6 $lineHeight="1">Q3 2024 Rewards</StyledContainer>
            </Row>
            <StyledContainer $height="20px"></StyledContainer>
            {
                rewardNode(checkHasVal(claimed?.q3), claimable?.q3, claimed?.q3)
            }
            <StyledContainer $height="32px"></StyledContainer>
            {
                checkHasVal(claimed.q3) && <ClaimedWrap>Rewards were claimed</ClaimedWrap>
            }
            {
                !checkHasVal(claimed.q3) && curClaimEnabled.q3 && checkHasVal(claimable.q3) && <AddNewBtnWrap $alignSelf="flex-start">
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold onClick={() => fnClaimRewards('202403')}>Claim all rewards</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            }
            {
                !curClaimEnabled.q3 && <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F">
                    You will be able to claim the rewards once they become available
                </StyledContainer>
            }
        </CardWrap>

        <CardWrap>
            <Row>
                <ImgCom imgUrl={getImg(claimed.q4, claimable.q4)} width="70px" height="70px"></ImgCom>
                <StyledContainer $ml="20px" $fontSize="16px" $fontWeight6 $lineHeight="1">Q4 2024 Rewards</StyledContainer>
            </Row>
            <StyledContainer $height="20px"></StyledContainer>
            {
                rewardNode(checkHasVal(claimed?.q4), claimable?.q4, claimed?.q4)
            }
            <StyledContainer $height="32px"></StyledContainer>
            {
                checkHasVal(claimed.q4) && <ClaimedWrap>Rewards were claimed</ClaimedWrap>
            }
            {
                !checkHasVal(claimed.q4) && curClaimEnabled.q4 && checkHasVal(claimable.q4) && <AddNewBtnWrap $alignSelf="flex-start">
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold onClick={() => fnClaimRewards('202404')}>Claim all rewards</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            }
            {
                !curClaimEnabled.q4 && <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F">
                    You will be able to claim the rewards once they become available
                </StyledContainer>
            }
        </CardWrap>
        <LoadingWin loading={isLock}></LoadingWin>
    </div>
}

const CardWrap = styled(Column)`
    border-radius: 9px;
    border: 1px solid #F2F2F2;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    padding: 30px;
    margin-bottom: 10px;
`

const ValWrap = styled(Column)`
    margin-right: 40px;
    &>span {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
        color: #767A7F;
    }

    &>div {
        font-size: 14px;
        line-height: 1;
        font-weight: 600;
        margin-top: 8px;
    }
`

const ClaimedWrap = styled(StyledContainer)`
    font-size: 14px;
    line-height: 1;
    font-weight: 600;
    padding: 9px 16px;
    border-radius: 6px;
    background-color: #DDF8EC;
    align-self: flex-start;
`


export default RewardsCom